import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unhandled error', error, info.componentStack);
  }

  private reset = () => {
    this.setState({ error: null });
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-4 p-6 text-center">
        <h1 className="text-xl font-semibold">Something went wrong</h1>
        <p className="text-ink-500 dark:text-ink-400 max-w-md text-sm">{error.message}</p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={this.reset}
            className="bg-brand-600 rounded-xl px-5 py-3 font-medium text-white"
          >
            Try again
          </button>
          <button
            type="button"
            onClick={() => globalThis.location.reload()}
            className="border-ink-300 dark:border-ink-700 rounded-xl border px-5 py-3 font-medium"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
